import React, {useEffect, useState} from 'react';
import {Header, Footer, Breadcrumb} from '../../components';
import {Link, useParams} from 'react-router-dom';
import styled from 'styled-components';
import mapBg from "../../assets/images/map/bg.jpg";
import PersonIcon from '@material-ui/icons/Person';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import {callApi} from "../../api";

const apiBoardViewData = {
    id: 1,
    number: 1,
    writer: "최고관리자",
    title: "강원도 민박예약홈페이지 및 통합예약시스템 구축안내",
    content: "<div id=\"bo_v_con\"><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">강원도 농어촌민박 활성화와 소득증대에 기여하고자 강원도청에서 예약사이트 구축비용을 지원 받아</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">강원도 민박공동홈페이지 및 실시간예약시스템을 강원도 농어촌민박협회에서 구축하고 있습니다.</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">&nbsp;</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">강원도 민박공동홈페이지가 구축되면 강원도지사 명의로 TV등 많은 언론 매체에 노출이 될 예정입니다.<br>예) 군산시 공공앱 \"배달의명수\"처럼 강원도청에서 전국 고객에게 TV등 언론 메체에 홍보 예정입니다.</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">&nbsp;</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">등록비는 무료입니다.</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">등록을 원하는 민박, 펜션은 첨부파일에 있는</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">1. \"01 강원도 통합예약시스템 구축 설명\" 다운로드 후&nbsp;읽어보시고</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">2. \"03 업체명_업체정보엑셀서식\" 작성</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">3. \"04 업체명_객실정보엘셀서식\" 작성</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">4. 객실별 사진 10장 이내(폴더별로 정리)<br>5. 펜션 전경 사진 10장 이내<br>6. 사업자등록증 사본(핸드폰으로 찍어도 됨)&nbsp;<br>7. 민박등록증 사본(핸드폰으로 찍어도 됨)</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">※ 2~7번까지 위쪽 \"폴더작성 예시\" 처럼 만들어 압축파일를 협회 사무국장 이메일로 보내 주시기 바랍니다.</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">※ 펜션 사진, 객실사진이 가지고 있지 않은 펜션,민박은 본인펜션 홈페이지 제작 업체에 요청하여 보세요.</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">&nbsp;</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">○ 이메일 주소 : kuhunmo<a href=\"mailto:hongpn@naver.com\" style=\"margin:0px;padding:0px;border:0px;vertical-align:baseline;color:rgb(0,0,0);\">@naver.com</a>&nbsp;</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">&nbsp;&nbsp;&nbsp;(메일 제목은 \"민박지역(ex&gt;춘천) + **펜션 통합 홈페이지 자료 발송\" 이렇게 부탁드립니다.)</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\">○ 민박협회 중앙회 전화번호 : 033-262-4422</p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\"><br></p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\"><b><span style=\"color:rgb(255,0,0);\">※ 업체 등록동의 및 사진 이용동의 페이지 :&nbsp;</span><a href=\"http://kwd.withusnet.com/inquiry/write\" style=\"font-family:'돋움', Dotum, Helvetica, sans-serif;\"><span style=\"color:rgb(255,0,0);\">http://kwd.withusnet.com/inquiry/write</span></a></b></p><p style=\"border:0px;vertical-align:baseline;font-family:NanumGothic, '맑은 고딕', malgun, MalgunGothic, sans-serif;background-color:rgb(244,244,244);\"><br></p></div>",
    date: "2020-11-17 16:29:17",
    hit: 123
};

const imageType = ['jpeg', 'jpg', 'png', 'gif'];

function PhotoView(props) {
    let {type, id} = useParams();

    const boardTitle = 'EVENT';


    const breadcrumb = [{
        id: 1,
        title: boardTitle,
        link: '/photo/' + type
    }];

    const imgExt = ['jpg', 'jpeg', 'gif', 'png'];

    const [boardData, setBoardData] = useState({});
    const [image, setImage] = useState([]);

    useEffect(() => {
        // 번호 내림차순
        // apiBoardData.sort(function(a, b) {
        //     return b.number - a.number;
        // });

        callApi('/board/detail/' + id, 'GET', {}).then((res) => {
            if (res.success) {

                setImage(res.data.file);
                setBoardData(res.data);
            }
        })
    }, []);

    if (Object.keys(boardData).length === 0) {
        return (<div>로딩중</div>);
    }

    return (
        <>
            <Header/>

            <StyledContainer>
                <div className="title-wrap">
                    <img src={mapBg} alt=""/>
                    <div className="title">
                        <span>{boardTitle}</span>
                    </div>
                </div>

                <Breadcrumb data={breadcrumb}/>

                <div className="category">
                    <div></div>
                    <div className="active">{boardTitle}</div>
                    <div></div>
                </div>

                <StyledCategoryContainer>
                    <div>
                        <h2>{boardData.title}</h2>
                    </div>
                    <div className="info">
                        <div>
                            <PersonIcon fontSize="small"/>
                            {boardData.writer}
                        </div>
                        <div>
                            <WatchLaterIcon fontSize="small"/>
                            {boardData.date}
                        </div>
                        <div>
                            <VisibilityIcon fontSize="small"/>
                            {boardData.hit}
                        </div>
                        {boardData.file.id !== undefined && (
                            <div>
                                <a href={process.env.REACT_APP_API_HOST + '/v1/download/board/' + boardData.file.id}
                                   target="_self">
                                    <AttachFileIcon fontSize="small"/>
                                    {boardData.file.real_file_name}.{boardData.file.ext}
                                </a>
                            </div>
                        )}
                    </div>
                    {
                        image.map(img => {
                            return (
                                /*첨부파일*/
                                <div key={img.id} style={{marginBottom: 20}}>
                                    <a href={process.env.REACT_APP_API_HOST + '/v1/download/board/' + img.id}
                                       target="_self">
                                        <AttachFileIcon fontSize="small"/>
                                        {img.real_file_name}.{img.ext}
                                    </a>
                                    {
                                        imgExt.indexOf(img.ext) > -1 && (
                                            /*이미지인경우*/
                                            <img key={img.id} src={img.file_url} alt={img.real_file_name}/>
                                        )
                                    }
                                </div>
                            );
                        })
                    }

                    <div style={{lineHeight: 1.4}} dangerouslySetInnerHTML={{__html: boardData.content}}>
                    </div>
                    <div className="bottom">
                        <Link to={"/photo/" + type}>
                            목록
                        </Link>
                    </div>
                </StyledCategoryContainer>
            </StyledContainer>

            <Footer/>
        </>
    );
}

const StyledContainer = styled.div`
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    
    // br {
    //     display: none;
    // }
    
    .title-wrap {
        position: relative;
        user-select: none;
        
        img {
            width: 100%;
        }
        
        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            font-size: 45px;
            font-weight: 200;
            text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
            
            span {
                font-weight: 600;
            }
        }        
    }
    
    .category {
        max-width: 1050px;
        display: flex;
        margin: 110px auto 30px;
        
        div {
            width: 100%;
            max-width: 440px;
            text-align: center;
            font-size: 24px;
            font-weight: 500;
            color: #434343;
            border-bottom: 2px solid #dcdcdc;
            
            &.active {
                width: 100%;
                max-width: 170px;
                border-bottom: 2px solid #f68b1f;
                padding-bottom: 12px;
            }
        }
    }
    
    @media (max-width: 940px) {
        margin: 60px auto 0;
    }
    
    @media (max-width: 475px) {
        br {
            display: block;
        }
    
        .title-wrap {
            img {
                height: 300px;
                object-fit: cover;
            }
            
            .title {
                font-size: 29px;
                text-align: center;
                width: 85%;
            }
        }
        
        .category {
            margin-top: 45px;
            
            div {
                font-size: 19px;
            }
        }
    }
`;

const StyledCategoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 30px auto 93px;
    max-width: 900px;
    padding: 0 20px;
  
    img {
        width: 100%;
        max-width: 100%;
        height: auto;
    }
    
    .info {
        display: flex;
        background-color: #ecebe2;
        padding: 10px;
        margin-bottom: 20px;
        
        svg {
            margin-right: 5px;
        }
        
        div {
            display: flex;
            align-items: center;
            font-size: 12px;
            line-height: 12px;
            margin-right: 20px;
            
            a {
                display: flex;
                align-items: center;
            }
        }
    }
    
    .bottom {
        border-top: 1px solid #dcdcdc;
        margin-top: 20px;
        padding-top: 20px;
        text-align: right;
        
        a {
            margin-top: 10px;
            padding: 10px;
            font-size: 14px;
            background-color: #fff;
            border: 1px solid #dcdcdc;
        }
    }
    
    @media (max-width: 450px) {
        .info {
            div {
                margin-right: 10px;
            }
        }
        
    }
`;

export default PhotoView;